import { Directive, effect, input, signal } from '@angular/core'

import { TemplateConfigInterface, fonts, theme } from '@flowx/core-sdk'
import { MessageStyles, applyMessageCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-message',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxMessageStyleDirective {
  componentStyle = input<{
    style: MessageStyles
    flowxProps: TemplateConfigInterface['displayOptions']['flowxProps']
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyMessageCustomStyles(
        this.componentStyle().style,
        theme(),
        fonts(),
        this.componentStyle().flowxProps.messageType,
        this.componentStyle().flowxProps.messageStyle
      )
      this.styleClassName.set(className)
    })
  }
}
